/**
 * First we will load all of this project's JavaScript dependencies.
 */
import './bootstrap';
import feather from 'feather-icons';

// Livewire v3 bundles Alpine internally — do NOT import or start Alpine separately.

// Initialize Feather Icons on initial load
document.addEventListener('livewire:initialized', () => {
    feather.replace();

    // Reinitialize after every Livewire DOM morph
    Livewire.hook('morph.updated', () => {
        feather.replace();
    });
});

// Fallback: also init on DOMContentLoaded (covers non-Livewire pages)
document.addEventListener('DOMContentLoaded', () => {
    if (window.feather) feather.replace();
});
